import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { SummaryItem } from '../../../models';
import { SummaryComponent } from '../../summary/summary.component';

@Component({
  selector: 'app-formly-summary',
  templateUrl: './formly-summary.component.html',
  styleUrl: './formly-summary.component.scss',
  imports: [SummaryComponent],
})
export class FormlySummaryComponent extends FieldType {
  get observableModel(): Observable<any> {
    return of(this.model);
  }

  get anyItems(): boolean {
    return this.field.props.fields.some((x) => this.model[x.key]);
  }

  summaryItems(): SummaryItem[] {
    return this.field.props.fields.map((x) => ({ label: x.label, value: this.model[x.key] }));
  }
}
